import { render, staticRenderFns } from "./admin2List.vue?vue&type=template&id=3da4eefe"
import script from "./admin2List.vue?vue&type=script&lang=js"
export * from "./admin2List.vue?vue&type=script&lang=js"
import style0 from "./admin2List.vue?vue&type=style&index=0&id=3da4eefe&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports